import { createWebHistory, createRouter } from "vue-router";

/* Layouts */
import App from "@layouts/App.vue";

/* Pages */
import Index from "@pages/Index.vue";
import Product from "@pages/Product.vue";
import Collection from "@pages/Collection.vue";
import About from "@pages/About.vue";
import Teams from "@pages/Teams.vue";
import Policy from "@pages/Policy.vue";
import NotFound from "@pages/404.vue";
/* Coming Soon */
import ComingSoon from "@pages/ComingSoon.vue";

/* Routes */
const routes = [
	{
		path: "/",
		component: App,
		children: [
			{
				path: "",
				name: "index",
				component: Index,
			},
			{
				path: "/product/:slug",
				name: "product",
				component: Product,
			},
			{
				path: "/collection/:slug",
				name: "collection",
				component: Collection,
			},
			{
				path: "/about",
				name: "about",
				component: About,
			},
			{
				path: "/teams",
				name: "teams",
				component: Teams,
			},
			{
				path: "/policy/:slug",
				name: "policy",
				component: Policy,
			},
			{
				path: "/:catchAll(.*)",
				name: "404",
				component: NotFound,
			},
		],
	},
];

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		if (to.name == from.name && !to.hash) {
			return { top: 0, behavior: "smooth" };
		} else if (to.hash) {
			return {
				el: to.hash,
				top: 100,
				behavior: "smooth",
			};
		} else {
			return {
				top: 0,
			};
		}
	},
	history: createWebHistory(),
	routes,
});

export default router;
